import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import { makeRecursiveMapper, mergeCellProps, collectNodes } from '../../utils';
import { FILL_COLUMN_CODE } from './autoFill';
var stateKey = 'columnDrag';

function sortColumns(cloumns, sort) {
  var res = new Array(cloumns.length);

  while (cloumns.length) {
    var cloumn = cloumns.pop();
    res[sort[cloumn.code]] = cloumn;
  }

  return res;
}

export function columnDrag() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (pipeline) {
    var _pipeline$getStateAtK = pipeline.getStateAtKey(stateKey, {}),
        cloumnsSortData = _pipeline$getStateAtK.cloumnsSortData,
        cloumnsTranslateData = _pipeline$getStateAtK.cloumnsTranslateData;

    var columns = pipeline.getColumns();

    if (cloumnsSortData) {
      columns = sortColumns(columns, cloumnsSortData);
    }

    pipeline.columns(_filterInstanceProperty(columns).call(columns, function (column) {
      return column;
    }));
    return pipeline.mapColumns(makeRecursiveMapper(function (col) {
      var style = cloumnsTranslateData ? {
        transition: '.3s',
        transform: "translate3d(".concat(cloumnsTranslateData[col.code], "px, 0px, 0px)")
      } : {};
      var prevGetCellProps = col.getCellProps; // !col.code: 选择列 col.lock: 固定列 不允许拖拽

      if (col.lock || !col.code) return col;
      return _extends(_extends({}, col), {
        getCellProps: function getCellProps(value, record, rowIndex) {
          var prevCellProps = prevGetCellProps === null || prevGetCellProps === void 0 ? void 0 : prevGetCellProps(value, record, rowIndex);
          return mergeCellProps(prevCellProps, {
            style: style
          });
        },
        headerCellProps: mergeCellProps(col.headerCellProps, {
          onMouseDown: function onMouseDown(e) {
            if (e.button !== 0) {
              return;
            } // const cx = e.clientX
            // const width = col.width
            // const a = startIndex
            // const b = endIndex
            // const newColumnDragData = [...columnDragData]
            // let newColumn = [...columns]
            // let newStartIndex = startIndex
            // let endIdx = endIndex


            var columnMoved = false;
            var columns = pipeline.getColumns();

            var _pipeline$getStateAtK2 = pipeline.getStateAtKey(stateKey, {}),
                cloumnsSortData = _pipeline$getStateAtK2.cloumnsSortData,
                cloumnsTranslateData = _pipeline$getStateAtK2.cloumnsTranslateData;

            if (cloumnsSortData) {
              columns = sortColumns(columns, cloumnsSortData);
            } else {
              cloumnsSortData = {};
              columns.forEach(function (item, index) {
                cloumnsSortData[item.code] = index;
              });
            }

            var currentTarget = e.currentTarget;
            var rect = e.currentTarget.parentElement.getClientRects()[0];
            var startX = rect.left;
            var moveData = [];

            function handleMouseMove(e) {
              if (e.clientX - startX < 20) {
                return;
              } else {
                e.stopPropagation();
              }

              document.body.style.userSelect = 'none';
              currentTarget.style.cursor = 'move'; // 计算平移位置

              var replaceIndex = 0;
              var totalWitdth = columns[replaceIndex].width;

              while (totalWitdth < e.clientX - startX && replaceIndex < columns.length - 1) {
                replaceIndex++;
                totalWitdth += columns[replaceIndex].width;
              } // 重置位置信息


              cloumnsTranslateData = {};
              columns.forEach(function (item) {
                cloumnsTranslateData[item.code] = 0;
              }); // 循环计算每一个的位置
              // if (startIndex !== replaceIndex) {
              //   const optionColumn = columns[startIndex]
              //   const move = startIndex > replaceIndex ? 1 : -1
              //   let index = Math.min(startIndex, replaceIndex)
              //   while (index < Math.max(startIndex, replaceIndex)) {
              //     const code = columns[index].code
              //     cloumnsTranslateData[code] += move * optionColumn.width
              //     cloumnsTranslateData[optionColumn.code] -= move * optionColumn.width
              //     index += move
              //   }
              // }
              // const opColumn = columns[startIndex]
              // let index = Math.min(startIndex, replaceIndex)
              // while (index <= Math.max(startIndex, replaceIndex)) {
              //   const code = columns[index].code
              //   if (index !== startIndex && index !== replaceIndex) {
              //     cloumnsTranslateData[code] += opColumn.width * (index > startIndex ? -1 : 1)
              //     cloumnsTranslateData[opColumn.code] += columns[index].width * (index < startIndex ? -1 : 1)
              //   }
              //   index++
              // }
              // 需要取最新startIndex, 不能直接用makeRecursiveMapper提供的startIndex（因为map时还没添加选择列、充满列等后面use添加的列）

              var startIndex;
              var leafColumns = collectNodes(collectNodes(columns, 'leaf-only'));
              leafColumns.forEach(function (column, index) {
                if (column.code === col.code) {
                  startIndex = index;
                }
              });
              var optionColumn = columns[startIndex];
              var index = replaceIndex;

              if (startIndex > replaceIndex) {
                // 左移
                while (index < startIndex) {
                  var code = columns[index].code;

                  if (code && code !== FILL_COLUMN_CODE && !columns[index].lock) {
                    cloumnsTranslateData[code] += optionColumn.width;
                    cloumnsTranslateData[optionColumn.code] -= columns[index].width;
                    columnMoved = true;
                  }

                  index++;
                }
              } else if (startIndex < replaceIndex) {
                // 右移
                while (startIndex < index) {
                  var _code = columns[index].code;

                  if (_code && _code !== FILL_COLUMN_CODE && !columns[index].lock) {
                    cloumnsTranslateData[_code] -= optionColumn.width;
                    cloumnsTranslateData[optionColumn.code] += columns[index].width;
                    columnMoved = true;
                  }

                  index--;
                }
              } else {// 不动或者移动回原位
              }

              window.requestAnimationFrame(function () {
                pipeline.setStateAtKey(stateKey, {
                  cloumnsSortData: cloumnsSortData,
                  cloumnsTranslateData: cloumnsTranslateData
                });
                moveData = [startIndex, replaceIndex];
              });
            }

            function handleMouseUp(e) {
              e.stopPropagation();
              document.body.removeEventListener('mousemove', handleMouseMove);
              document.body.removeEventListener('mouseup', handleMouseUp);
              window.requestAnimationFrame(function () {
                var _moveData = moveData,
                    _moveData2 = _slicedToArray(_moveData, 2),
                    startIndex = _moveData2[0],
                    replaceIndex = _moveData2[1];

                var optionColumn = columns[startIndex]; // const move = startIndex > replaceIndex ? 1 : -1
                // let index = Math.min(startIndex, replaceIndex)
                // while (index < Math.max(startIndex, replaceIndex) && index > 0) {
                //   const code = columns[index].code
                //   cloumnsSortData[optionColumn.code] -= move
                //   cloumnsSortData[code] += move
                //   index += move
                // }

                var index = replaceIndex;

                if (startIndex > replaceIndex) {
                  // 左移
                  while (index < startIndex) {
                    var code = columns[index].code;

                    if (code && code !== FILL_COLUMN_CODE && !columns[index].lock) {
                      cloumnsSortData[code] += 1;
                      cloumnsSortData[optionColumn.code] -= 1;
                      columnMoved = true;
                    }

                    index++;
                  }
                } else if (startIndex < replaceIndex) {
                  // 右移
                  while (index > startIndex) {
                    var _code2 = columns[index].code;

                    if (_code2 && _code2 !== FILL_COLUMN_CODE && !columns[index].lock) {
                      cloumnsSortData[_code2] -= 1;
                      cloumnsSortData[optionColumn.code] += 1;
                      columnMoved = true;
                    }

                    index--;
                  }
                }

                var onColumnDragStopped = opts.onColumnDragStopped; // 拖拽结束返回列顺序

                if (onColumnDragStopped) {
                  var _context;

                  var newColumns = _filterInstanceProperty(_context = sortColumns(columns, cloumnsSortData)).call(_context, function (_ref) {
                    var code = _ref.code;
                    return code !== FILL_COLUMN_CODE;
                  }); // TODO drag需要在resize之后use,否则这里返回的列对应的宽度不是拖拽后的


                  onColumnDragStopped(columnMoved, newColumns);
                }

                pipeline.setStateAtKey(stateKey, {
                  cloumnsSortData: cloumnsSortData,
                  cloumnsTranslateData: null
                });
              });
              document.body.style.userSelect = '';
              currentTarget.style.opacity = '';
              currentTarget.style.cursor = '';
              currentTarget = null;
            }

            document.body.addEventListener('mousemove', handleMouseMove);
            document.body.addEventListener('mouseup', handleMouseUp);

            document.body.onselectstart = function () {
              return false;
            };
          },
          style: style
        })
      });
    }));
  };
}